<template>
    <div class="page-wrapper">
        <div class="container-fluid p-0">
            <div class="row">
                <div class="col-12">
                    <div class="login-card login-dark">
                        <div>
                            <div>
                                <router-link class="logo" to="/"><img class="img-fluid for-light m-auto"
                                        src="@/assets/images/logo/logo1.png" alt="looginpage" /><img class="for-dark"
                                        src="@/assets/images/logo/logo-dark.png" alt="logo" /></router-link>
                            </div>
                            <div class="login-main">
                                <form class="theme-form">
                                    <h2>Reset Your Password</h2>
                                    <div class="form-group">
                                        <label class="col-form-label">Enter your email</label>
                                        <div class="form-input position-relative">
                                            <input class="form-control" type="text" name="login[password]" required
                                                placeholder="*********@gmail.com" />
                                        </div>
                                    </div>
                                    <div class="form-group mb-0 checkbox-checked">
                                        <button class="btn btn-primary btn-block w-100 mt-3" type="submit">
                                            SEND
                                        </button>
                                    </div>
                                    <p class="mt-4 mb-0 text-center">
                                        Already have an password?<router-link class="ms-2" to="/">Sign in</router-link>
                                    </p>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref } from "vue";
const type = ref<string>("password");
function showPassword() {
    if (type.value === "password") {
        type.value = "text";
    } else {
        type.value = "password";
    }
}
</script>
